/*
Blue Newt Software, Inc. Confidential Unpublished Copyright
(c) 2008-2018 Blue Newt Software, Inc., All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of Blue
Newt Software, Inc. The intellectual and technical concepts contained herein
are proprietary to Blue Newt Software, Inc. and may be covered by U.S. and
Foreign Patents, patents in process, and are protected by trade secret or
copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Blue Newt Software, Inc. Access to the source code contained herein is
hereby forbidden to anyone except current Blue Newt Software, Inc. employees,
managers or contractors who have executed  Confidentiality and Non-disclosure
agreements explicitly covering such access.

The copyright notice above does not evidence any actual or intended
publication or disclosure of this source code, which includes  information
that is confidential and/or proprietary, and is a trade secret, of Blue Newt
Software, Inc. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC
PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE WITHOUT
THE EXPRESS WRITTEN CONSENT OF Blue Newt Software, Inc. IS STRICTLY
PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES.
THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES
NOT CONVEY OR IMPLY ANY RIGHTS  TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS
CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE, IN
WHOLE OR IN PART.
*/

import React from 'react';
import {Popover, OverlayTrigger, Checkbox} from 'react-bootstrap';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import FaSearch from 'react-icons/lib/fa/search';
import FaAngleDown from 'react-icons/lib/fa/angle-down';
import MdClose from 'react-icons/lib/md/close';

import './filterWidgets-styles.css';

export function setFilterValue(currentFilters, filter, checked) {
  let filterOption = filter.toLowerCase();

  if (filter === 'all') {
    return [];
  }

  let optionIndex = currentFilters.indexOf(filterOption);

  if (checked) {
    optionIndex === -1 ? currentFilters.push(filterOption) : console.log("Filter option already set");
  }
  else {
    optionIndex !== -1 ? currentFilters.splice(optionIndex, 1) : console.log("Filter option not set");
  }

  return currentFilters;
}

export function getFilterWidget(filterPopover, onChangeCallback, hasActiveFilters) {
  let buttonClass = hasActiveFilters ? "search-title-header filtered" : "search-title-header";

  return (
    <div>
      {hasActiveFilters &&
        <div
          className="filter-close-button"
          onClick={(e) => onChangeCallback(setFilterValue([], 'all', true))}
        >
          <MdClose className='close-icon'/>
        </div>
      }
      <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={filterPopover}>
        <div className={buttonClass}>
          <div className="per-col-search-widget">
            <FaSearch />
            <FaAngleDown />
          </div>
        </div>
      </OverlayTrigger>
    </div>
  );
}

export function SelectionFilterWidget(currentFilters, allFilters, onChangeCallback) {
  let filterBoxes = allFilters.map((filter) => {
    return (
      <Checkbox
        key={filter}
        name={filter}
        checked={filter && currentFilters.indexOf(filter.toLowerCase()) !== -1}
        onChange={(e) => onChangeCallback(setFilterValue(currentFilters, filter, e.target.checked))}
      >
        {filter}
      </Checkbox>
    );
  });

  const popover = (
    <Popover id="filterPopover">
      <div className="filterBoxes">
        <Checkbox
          checked={currentFilters.length === 0}
          onChange={(e) => onChangeCallback(setFilterValue(currentFilters, 'all', e.target.checked))}
        >
          <strong>Show All</strong>
        </Checkbox>
        <div className="divider"/>
        {filterBoxes}
      </div>
    </Popover>
  );
  
  return getFilterWidget(popover, onChangeCallback, (currentFilters.length > 0));
}

export function TimeFilterWidget(currentFilters, onChangeCallback) {
  const popover = (
    <Popover id="filterPopover">
      <div className="filterBoxes">
        <Checkbox checked={Object.keys(currentFilters).length === 0} onChange={(e) => onChangeCallback({})}>
          <strong>Show All</strong>
        </Checkbox>
        <div className="divider"/>
        <div className="timePicker">
          <strong className='timeLabel'>From:</strong>
          <DateTimePicker defaultValue={currentFilters.from} calendar={false} time={true} onChange={(date) => onChangeCallback(Object.assign({}, currentFilters, {from: date}))}/>
        </div>
        <div className="timePicker">
          <strong className='timeLabel'>To:</strong>
          <DateTimePicker defaultValue={currentFilters.to} calendar={false} time={true} onChange={(date) => onChangeCallback(Object.assign({}, currentFilters, {to: date}))}/>
        </div>
      </div>
    </Popover>
  );

  return getFilterWidget(popover, onChangeCallback, (Object.keys(currentFilters).length > 0));
}



// WEBPACK FOOTER //
// ./src/vendor/signal-widgets/filterWidgets.js